import { ChangeDetectorRef, Component, ElementRef, OnInit, Renderer2, ViewChild, Input } from '@angular/core';
import { SwiperDirective } from '../directives/swiper.directive';
import * as jQuery from 'jquery';

@Component({
	selector: 'app-section-carousel-item',
	templateUrl: './section-carousel-item.component.html',
	styleUrls: ['./section-carousel-item.component.css']
})
export class SectionCarouselItemComponent implements OnInit {
	static transitionStyle: any = {};

	@ViewChild('carouselItem') el: ElementRef;
	@Input() slideContent: any;
	@ViewChild(SwiperDirective) swiper: SwiperDirective;
	public slideHTML = '';

	speed: number;
	currentPosition = 0;
	position = 0;
	zIndex: number;

	constructor(private renderer: Renderer2) {}

	ngOnInit() {
		const slideItemObj = this.slideContent;
		const widget =
			'<app-' +
			slideItemObj.widgetType +
			' sectiontitle="' +
			slideItemObj.widgetTitle +
			'" path="' +
			slideItemObj.path +
			'"  datatableconfig="' +
			encodeURI(slideItemObj.dataTableConfig) +
			'" timeserieskey="' +
			slideItemObj.query.timeseriesKey +
			'" downloadcsvcolumns="' +
			encodeURI(slideItemObj.downloadCSVColumns) +
			'" tertiarykey="' +
			slideItemObj.query.tertiaryKey +
			'" key="' +
			slideItemObj.query.key +
			'" colcount="' +
			slideItemObj.colCount +
			'" heatmapenabled="' +
			slideItemObj.heatmapEnabled +
			'" liftdistributionenabled="' +
			slideItemObj.liftDistributionEnabled +
			'" liftareacolor="' +
			slideItemObj.liftAreaColor +
			'" groupby="' +
			slideItemObj.query.groupBy +
			'" fields="' +
			encodeURI(slideItemObj.query.fields) +
			'" sectionclass="' +
			slideItemObj.widgetClass +
			'" markericon="' +
			slideItemObj.markerIcon +
			'" placeholderimage="' +
			slideItemObj.placeholderImage +
			'"  colorsconfig="' +
			encodeURI(slideItemObj.colorConfig) +
			'"  downloadconfig="' +
			encodeURI(slideItemObj.downloadConfig) +
			'"  chartconfiguration="' +
			encodeURI(slideItemObj.chartConfiguration) +
			'"  externalwidgetsconfiguration="' +
			encodeURI(slideItemObj.externalWidgetsConfiguration) +
			'"  metricsarray="' +
			encodeURI(slideItemObj.metricsArray) +
			'"  barchartconfiguration="' +
			encodeURI(slideItemObj.barChartConfiguration) +
			'"  reportingconfig="' +
			encodeURI(slideItemObj.reportingConfig) +
			'"  legend="' +
			encodeURI(slideItemObj.legend) +
			'" colors="' +
			slideItemObj.colors +
			'" removekeys="' +
			encodeURI(slideItemObj.removeKeys) +
			'" defaultsort="' +
			slideItemObj.defaultSort +
			'" columnsconfig="' +
			encodeURI(slideItemObj.columnsConfig) +
			'"  downloadcsvcolumns="' +
			encodeURI(slideItemObj.downloadCSVColumns) +
			'" queryorderby="' +
			encodeURI(slideItemObj.queryOrderBy) +
			'" iscustomendpoint="' +
			encodeURI(slideItemObj.query.isCustomEndPoint) +
			'" downloadcsvorderby="' +
			encodeURI(slideItemObj.downloadCSVOrderBy) +
			'" customchartconfiguration="' +
			encodeURI(slideItemObj.customChartConfiguration) +
			'" showalldatesdata=' +
			slideItemObj.showAllDatesData +
			'>' +
			'" nodatamessage="' +
			slideItemObj.noDataMessage +
			'">' +
			' </app-' +
			slideItemObj.widgetType +
			'>';
		const className = this.getClassByWidgetLayout(slideItemObj.widgetLayout);
		const widgetOuterContainer = jQuery('<div class="widgets"></div>');
		jQuery(widgetOuterContainer).addClass(className);
		jQuery(widgetOuterContainer).append(widget);

		this.slideHTML = jQuery(widgetOuterContainer)[0].outerHTML; // ###setting widget into the slide
	}

	get transition() {
		return SectionCarouselItemComponent.transitionStyle;
	}

	set transition(transitionStyle) {
		SectionCarouselItemComponent.transitionStyle = transitionStyle;
	}

	moveTo(position: number) {
		this.renderer.setStyle(this.el.nativeElement, 'transform', 'translate3d(' + position + 'px, 0px, 0px)');
		this.renderer.setStyle(this.el.nativeElement, '-webkit-transform', 'translate3d(' + position + 'px, 0px, 0px)');
		this.renderer.setStyle(this.el.nativeElement, '-moz-transform', 'translate3d(' + position + 'px, 0px, 0px)');
		this.renderer.setStyle(this.el.nativeElement, '-o-transform', 'translate3d(' + position + 'px, 0px, 0px)');
		this.renderer.setStyle(this.el.nativeElement, '-ms-transform', 'translate3d(' + position + 'px, 0px, 0px)');
	}

	moveBy(distance: number) {
		this.renderer.setStyle(this.el.nativeElement, 'transform', 'translate3d(' + distance + 'px, 0px, 0px)');
		this.renderer.setStyle(this.el.nativeElement, '-webkit-transform', 'translate3d(' + distance + 'px, 0px, 0px)');
		this.renderer.setStyle(this.el.nativeElement, '-moz-transform', 'translate3d(' + distance + 'px, 0px, 0px)');
		this.renderer.setStyle(this.el.nativeElement, '-o-transform', 'translate3d(' + distance + 'px, 0px, 0px)');
		this.renderer.setStyle(this.el.nativeElement, '-ms-transform', 'translate3d(' + distance + 'px, 0px, 0px)');
	}

	setzIndex(zIndex: number) {
		this.renderer.setStyle(this.el.nativeElement, 'z-index', zIndex);
	}

	disableTransition() {
		this.renderer.setStyle(this.el.nativeElement, 'transition', 'none');
		this.renderer.setStyle(this.el.nativeElement, '-moz-transition', 'none');
		this.renderer.setStyle(this.el.nativeElement, '-webkit-transition', 'none');
		this.renderer.setStyle(this.el.nativeElement, '-o-transition', 'none');
		this.renderer.setStyle(this.el.nativeElement, '-ms-transition', 'none');
	}

	enableTransition() {
		this.renderer.setStyle(this.el.nativeElement, 'transition', 'transform');
		this.renderer.setStyle(this.el.nativeElement, '-moz-transition', 'transform');
		this.renderer.setStyle(this.el.nativeElement, '-webkit-transition', 'transform');
		this.renderer.setStyle(this.el.nativeElement, '-o-transition', 'transform');
		this.renderer.setStyle(this.el.nativeElement, '-ms-transition', 'transform');

		this.renderer.setStyle(this.el.nativeElement, 'transition-duration', this.speed + 'ms');
		this.renderer.setStyle(this.el.nativeElement, '-moz-transition-duration', this.speed + 'ms');
		this.renderer.setStyle(this.el.nativeElement, '-webkit-transition-duration', this.speed + 'ms');
		this.renderer.setStyle(this.el.nativeElement, '-o-transition-duration', this.speed + 'ms');
		this.renderer.setStyle(this.el.nativeElement, '-ms-transition-duration', this.speed + 'ms');
	}

	fadeOut(duration: number): any {
		return new Promise((resolve) => {
			this.renderer.setStyle(this.el.nativeElement, 'opacity', '0');
			setTimeout(() => {
				this.renderer.setStyle(this.el.nativeElement, 'opacity', '1');
				resolve(true);
			}, duration);
		});
	}

	fadeIn(duration: number): any {
		this.renderer.setStyle(this.el.nativeElement, 'opacity', '0');
		setTimeout(() => {
			this.renderer.setStyle(this.el.nativeElement, 'transition', `opacity ${duration}ms`);
			this.renderer.setStyle(this.el.nativeElement, 'opacity', '1');
		}, 0);
	}

	getClassByWidgetLayout(layoutSize: any): string {
		return `analytics-portlet-${layoutSize}p`;
	}
}
